import React from 'react'

const Home = () => <div>test</div>

export default Home
